/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
import SweetAlert from "./SweetAlert";
import Paginate from 'vuejs-paginate';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('campaigns-all-logs', require('./components/CampaignsAllLogs.vue').default);
Vue.component('campaigns', require('./components/Campaigns.vue').default);
Vue.component('campaign-members', require('./components/CampaignMembers.vue').default);
Vue.component('badge', require('./components/Badge.vue').default);
Vue.component('progress-bar', require('./components/Progress.vue').default);
Vue.component('spinner', require('./components/Spinner.vue').default);
Vue.component('campaign-status', require('./components/CampaignStatus.vue').default);
Vue.component('performer-members', require('./components/PerformerMembers.vue').default);
Vue.component('performer-members-import', require('./components/PerformerMembersImport.vue').default);
Vue.component('system-info', require('./components/SystemInfo.vue').default);
Vue.component('processes', require('./components/Processes.vue').default);
Vue.component('paginate', Paginate);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip()

    $('form.form-confirm button[type="submit"]').click(function (e) {
        e.preventDefault();
        const form = $(this).parent('.form-confirm');
        if (form) {
            const title = form.data('confirm') ? form.data('confirm') : 'Are you sure?';
            SweetAlert.confirm({title: title}).then((result) => {
                if (result.isConfirmed) {
                    $(this).attr('disabled', true).addClass('disabled');
                    form.submit();
                }
            });
        }
    });

    $('.custom-file input').change(function (e) {
        var files = [];
        for (var i = 0; i < $(this)[0].files.length; i++) {
            files.push($(this)[0].files[i].name);
        }
        $(this).next('.custom-file-label').html(files.join(', '));
    });

    $('#btn-logout').click(e => {
        e.preventDefault();
        const answer = confirm('Are you sure?');
        if (answer) {
            $('#form-logout').submit();
        }
    });

    // $('button[type="submit"]').click(function () {
    //     $(this).attr('disabled', true);
    // });
});
